import Enderecos from './Enderecos';

export default Enderecos;
